<div class="step-produtos space-y-6">
  <div class="flex justify-between items-center">
    <p-button
      label="Cadastrar novo produto"
      icon="pi pi-plus-circle"
      severity="secondary"
      [text]="true"
      (click)="requestNewProduct.emit()"
    ></p-button>
    <div class="flex gap-2 items-center">
      <span class="text-sm font-medium text-gray-700">Total produtos: {{ totalProductsFormatted }}</span>
      <p-button
        label="Adicionar produto"
        icon="pi pi-plus"
        severity="secondary"
        (click)="addItem()"
      ></p-button>
    </div>
  </div>

  <div class="bg-white shadow rounded overflow-x-auto" [formGroup]="parentForm">
    <div formArrayName="items">
      <p-table
        [value]="itemsArray.controls"
        [paginator]="false"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm"
      >
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Produto</th>
            <th class="text-left px-6 py-3" style="width: 100px;">Quantidade</th>
            <th class="text-left px-6 py-3" style="width: 120px;">Preço unit.</th>
            <th class="text-left px-6 py-3" style="width: 100px;">Desconto</th>
            <th class="text-left px-6 py-3" style="width: 120px;">Total</th>
            <th class="text-left px-6 py-3" style="width: 80px;">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-i="rowIndex">
          <tr [formGroupName]="i" [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 align-middle">
              <p-dropdown
                formControlName="productId"
                [options]="productOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione o produto"
                [filter]="true"
                filterBy="label,code,description"
                appendTo="body"
                class="w-full"
                (onFilter)="onProductFilter($event)"
                (onChange)="onProductSelect(i, $event)"
              ></p-dropdown>
            </td>
            <td class="px-6 py-2 align-middle">
              <p-inputNumber
                formControlName="quantity"
                [min]="0.001"
                [minFractionDigits]="0"
                [maxFractionDigits]="3"
                class="w-full"
              ></p-inputNumber>
            </td>
            <td class="px-6 py-2 align-middle">
              <p-inputNumber
                formControlName="unitPrice"
                mode="currency"
                currency="BRL"
                locale="pt-BR"
                [min]="0"
                class="w-full"
              ></p-inputNumber>
            </td>
            <td class="px-6 py-2 align-middle">
              <p-inputNumber
                formControlName="discount"
                mode="currency"
                currency="BRL"
                locale="pt-BR"
                [min]="0"
                class="w-full"
              ></p-inputNumber>
            </td>
            <td class="px-6 py-2 text-sm font-medium text-gray-900">
              {{ getRowTotal(row) }}
            </td>
            <td class="px-6 py-2 align-middle">
              <p-button
                icon="pi pi-trash"
                [text]="true"
                severity="danger"
                (click)="removeItem(i)"
                [disabled]="itemsArray.length <= 1"
                pTooltip="Remover"
              ></p-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center py-8 text-gray-500">
              Nenhum produto adicionado. Clique em &quot;Adicionar produto&quot;.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
